import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CATALOG } from 'src/core-lib/misselaineous/boot.tokens';
import { CustomerService } from 'src/customer/services/customer.service';

@Component({
    selector: 'app-customer-menu',
    standalone: true,
    imports: [RouterModule, TranslateModule],
    templateUrl: './customer-menu.component.html',
    styleUrl: './customer-menu.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomerMenuComponent {
    constructor(
        public customerService: CustomerService,
        @Inject(CATALOG) public catalog: string,
    ) {
    }
}
